import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as s, useEffect as c } from "react";

function g(t) {
  var _s = s(typeof t == "object" ? t : null),
      _s2 = _slicedToArray(_s, 2),
      a = _s2[0],
      e = _s2[1];

  return c(function () {
    typeof t == "string" && function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n) {
        var r;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(n);

              case 3:
                _context.next = 5;
                return _context.sent.json();

              case 5:
                r = _context.sent;
                e(r);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.error("Error fetching GlobalNavigation data:", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()(t);
  }, [t]), a;
}

export { g as useGlobalNavigation };